import React from 'react';
import CircleButton from './CircleButton';
export default function ShareButton({ type, ...props }) {
    return (React.createElement(CircleButton, Object.assign({ bg: "smokeDark", borderRadius: "50%", boxShadow: "none", color: "white", height: 32, hoverBg: type, hoverBoxShadow: "none", hoverColor: "white", width: 32 }, props)));
}
